import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from 'vue'
import debounce from "foundation/js/debounce";

export default {
    name: "DirectMessageNavigation",
    props: {
        guid: {
            type: String,
            required: true
        },
        userData: {
            type: Object,
            required: true
        },
        chatId: {
            type: String,
            required: false
        }
    },
    setup(props){
        const store = useStore()
        const inputText = ref('')
        const results = ref([])
        const showSpinner = computed(() => store.state.forum.is_submitting)
        const allThreads = computed(() => store.state.forum.direct_message_threads)
        const totalMessageThreads = computed(() => store.state.forum.direct_message_threads_data)
        const skip = ref(0)
        const take = computed(() => store.state.forum.direct_message_threads_take)
        const getMoreMessageThreads = ref(false);
        var profileId = "";

        onMounted(() => {        
            profileId = new URLSearchParams(document.location.search).get('profile')    
            getDirectMessageThreads(true);
        })

        watch(() => allThreads.value, (newValue) => {
            results.value = newValue;
            getMoreMessageThreads.value = (allThreads.value.length) < totalMessageThreads.value.totalHits
        })

        const scrollTreadInToView = function () {
            const thread = document.querySelector('.kb-direct-messages-content__right-wrapper')
            if (thread) {
                thread.scrollIntoView({  behavior: 'smooth' })
            }
        }

        const handleInputText = (e) => {
            debounce(() => {
                searchMessages()
            }, 500)()
        }

        const searchMessages = function () {
            if (inputText.value === '') {
                results.value = allThreads.value
                return
            }  

            const searchResults = []
            allThreads.value.map((result) => {
                if (result.chatName.toLowerCase().includes(inputText.value.toLowerCase())) {
                    searchResults.push(result)
                }
            })

            results.value = searchResults
        }

        

        const getDirectMessageThreads = function (loadFirstChat = false) {
            store.dispatch('forum/getDirectMessageThreads', { 
                userId: props.userData.userId, 
                chatId: props.chatId, 
                toProfileId: profileId, 
                skip: skip.value,
                take: take.value,
                loadFirstChat: loadFirstChat
            })
        }        

        const loadMoreMessageThreads = function () {
            skip.value = (take.value + skip.value)
            getDirectMessageThreads()
        }

        const startNewMessage = function () {
            store.dispatch('forum/clearDirectMessageThread')
            scrollTreadInToView()
        }

        const changeChat = function (chatId) {
            store.dispatch('forum/clearDirectMessageThread')

            store.dispatch('forum/getDirectMessageThreadData', { 
                chatId,
                userId: props.userData.userId
             })
             scrollTreadInToView()
        }

        return {
            showSpinner,
            inputText,
            results,
            getMoreMessageThreads,
            handleInputText,
            searchMessages,
            loadMoreMessageThreads,
            startNewMessage,
            changeChat,
            getLabel: (labelKey) =>
                store.getters["labels/getLabel"]({
                    labelCollection: "DirectMessageNavigation",
                    labelKey,
                }),
        }
    }
}